import {
  GuestRequest as SharedGuestRequest,
  GuestRequestStatus,
  GuestRequestType
} from "shared/dist/types/GuestRequest";
import {
  GUEST_REQUEST_STATUSES as SharedGuestRequestStatuses,
  GUEST_REQUEST_TYPES as SharedGuestRequestTypes,
} from "shared/dist/types/GuestRequest";

export type {
  GuestRequestType,
  GuestRequestStatus,
};

export const GUEST_REQUEST_STATUSES = SharedGuestRequestStatuses;
export const GUEST_REQUEST_TYPES = SharedGuestRequestTypes;

export default interface GuestRequest extends SharedGuestRequest {}